<template>
  <div class="offer-container offer-table2 asset-container">
    <LandingBarAdmin active="portfolio" />
    <v-overlay :value="loading">
      <div class="loading-auto" v-if="loading">
        <v-progress-circular
          :size="70"
          :width="4"
          color="#dc5b21"
          indeterminate
        ></v-progress-circular>
      </div>
    </v-overlay>
    <div class="offer-inner-container">
      <v-breadcrumbs :items="bread" divider=">"></v-breadcrumbs>
      <div class="table-top-flex">
        <div class="upload-title">
          <h3 class="table-headline">Upload Offers</h3>
          <v-dialog v-model="panelModal" width="800">
            <template v-slot:activator="{ on }">
              <v-icon right class="modal-icon" v-on="on" color="#58c26d">
                mdi-information
              </v-icon>
            </template>

            <v-card class="q3-dialog">
              <v-card-title class="text-h5 grey lighten-2">
                Location codes
              </v-card-title>

              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">Name</th>
                      <th class="text-left">Code</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in getLoc" :key="item.locationCode">
                      <td>{{ item.locationName }}</td>
                      <td>{{ item.locationCode }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>

              <v-divider></v-divider>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="primary"
                  text
                  v-on:click="() => (panelModal = false)"
                >
                  Close
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </div>
        <v-btn
          href="https://eflex.file.core.windows.net/excel-template/offers.xlsx?sv=2021-06-08&ss=bfqt&srt=sco&sp=rlf&se=2024-03-06T23:00:00Z&st=2023-03-07T09:00:00Z&spr=https&sig=f4maKfBFDuFhS3Vr7MNZPkwVU4E2wyh%2FCoJhJXj4z%2Bk%3D"
          download
          depressed
          tile
          color="#58c26d"
          class="search-button"
          large
        >
          Download Excel template file to upload
        </v-btn>
        <upload-excel-component
          :on-success="handleSuccess"
          :before-upload="beforeUpload"
        />
        <v-btn
          :disabled="tableData.length < 1 || loading"
          :loading="loading"
          depressed
          tile
          color="#58c26d"
          class="search-button"
          large
          v-on:click="importOffers"
        >
          Import
        </v-btn>
        <div v-if="success" class="success-text">Offers imported!</div>
        <div v-if="error" class="error-text">
          Error importing offers, please try again.
        </div>
      </div>
      <div class="offer-inner-container">
        <v-data-table
          :header-props="{ sortIcon: icons.mdiArrowUpBold }"
          :headers="headers"
          :items="tableData"
          :search="search"
        >
        </v-data-table>
      </div>
    </div>
    <div class="offer-container"></div>
  </div>
</template>

<script>
import moment from "moment";

import LandingBarAdmin from "../../components/Common/LandingBarAdmin.vue";

import UploadExcelComponent from "../../components/Excel/UploadExcel.vue";

import { mdiMagnify, mdiPlus, mdiArrowUpBold, mdiCloseCircle } from "@mdi/js";

import CountryDataService from "../../services/CountryDataService";
import OfferDataService from "../../services/OfferDataService";
import LocationDataService from "../../services/LocationDataService";

export default {
  name: "UploadExcel",
  components: { LandingBarAdmin, UploadExcelComponent },
  data() {
    return {
      tableData: [],
      tableHeader: [],
      loading: false,
      count: 0,
      panelModal: false,
      icons: {
        mdiMagnify,
        mdiPlus,
        mdiArrowUpBold,
        mdiCloseCircle,
      },
      headers: [
        { text: "No.", value: "id" },
        {
          text: "Type",
          align: "start",
          value: "assetType",
        },
        { text: "Name", value: "assetName" },
        { text: "Capacity", value: "assetCapacity" },
        { text: "Capacity", value: "unit" },
        { text: "Latitude", value: "assetLat" },
        { text: "Longitude", value: "assetLong" },
        { text: "Address", value: "assetAddress" },
        { text: "City", value: "assetCity" },
        { text: "Postcode", value: "assetPostCode" },
        { text: "Bid deadline", value: "bidDeadline" },
      ],
      offer: {
        id: null,
        companyCode: this.$store.state.auth.user.companyCode,
        assetCode: "",
        assetName: "",
        offerCode: "",
        dayType: "",
        locationCode: "",
        dateFrom: "",
        dateTo: "",
        timeFrom: "",
        timeTo: "",
        volume: "",
        price: "",
      },
      headers: [
        { text: "No.", value: "id" },
        {
          text: "Location",
          align: "start",
          value: "locationCode",
        },
        { text: "Asset", value: "assetCode" },
        { text: "When", value: "dayType" },
        { text: "Date from", value: "dateFrom" },
        { text: "Date to", value: "dateTo" },
        { text: "Time from", value: "timeFrom" },
        { text: "Time to", value: "timeTo" },
        { text: "Volume", value: "volume" },
        { text: "Unit", value: "unit" },
        { text: "Price", value: "price" },
        { text: "Bid deadline", value: "bidDeadline" },
      ],
      submitted: false,
      countries: [],
      loc: [],
    };
  },
  methods: {
    beforeUpload(file) {
      const isLt1M = file.size / 1024 / 1024 < 1;

      if (isLt1M) {
        return true;
      }

      this.$message({
        message: "Please do not upload files larger than 1m in size.",
        type: "warning",
      });
      return false;
    },

    handleSuccess({ results, header }) {
      console.log("Table Header: ", header);
      console.log("Table Data: ", results);
      this.tableData = results;
      this.tableHeader = header;
    },

    retrieveCountries() {
      /* 
      CountryDataService.getAll()
        .then((response) => {
          this.countries = response.data;
          console.log("HERE... load countries sucessfull: " + response.data);
        })
        .catch((e) => {
          console.log("HERE... load countries error: " + e);
        });
       */
      console.log(
        "HERE... currentUser's role: " + this.$store.state.auth.user.roles
      );
      console.log(
        "HERE... currentUser's country: " +
          this.$store.state.auth.user.countryCode
      );
      if (this.$store.state.auth.user.roles == "ROLE_ADMIN") {
        CountryDataService.getAll()
          .then((response) => {
            this.countries = response.data;
            console.log("HERE... load countries sucessfull: " + response.data);
          })
          .catch((e) => {
            console.log("HERE... load countries error: " + e);
          });
      } else {
        CountryDataService.findByCountryCode(
          this.$store.state.auth.user.countryCode
        )
          .then((response) => {
            this.countries = response.data;
            console.log(
              "HERE... load country sucessfull: " + this.countries.countryCode
            );
          })
          .catch((e) => {
            console.log("HERE... load country error: " + e);
          });
      }
    },

    saveOffer(last) {
      var data = {
        companyCode: this.offer.companyCode,
        locationCode: this.offer.locationCode,
        assetCode: this.offer.assetCode,
        offerCode: this.offer.offerCode,
        dayType: this.offer.dayType,
        dateFrom: this.offer.dateFrom,
        dateTo: this.offer.dateTo,
        timeFrom: this.offer.timeFrom,
        timeTo: this.offer.timeTo,
        volume: this.offer.volume,
        price: this.offer.price,
        bidDeadline: this.offer.bidDeadline,
        bcId: this.offer.bcId,
      };

      OfferDataService.create(data)
        .then((response) => {
          this.count = this.count + 1
          this.offer.id = response.data.id;
          this.submitted = true;
          if (this.tableData.length === this.count) {
            this.loading = false;
            this.$router.push({ name: "offers" });
          }
        })
        .catch((e) => {
          this.count = this.count + 1
          if (this.tableData.length === this.count) {
            this.loading = false;
            this.$router.push({ name: "offers" });
          }
          console.log(e);
        });
    },

    async importOffers() {
      this.loading = true;
      this.count = 0;
      var uDateFrom = [];
      var uDateTo = [];
      var uTimeFrom = [];
      var uTimeTo = [];
      var uVolume = [];
      var uPrice = [];
      var uploadBcId = [];
      let promiseArray = [];

      for (var i = 0; i < this.tableData.length; i++) {
        uDateFrom.push(this.tableData[i].dateFrom);
        uDateTo.push(this.tableData[i].dateTo);
        uTimeFrom.push(this.tableData[i].timeFrom);
        uTimeTo.push(this.tableData[i].timeTo);
        uVolume.push(this.tableData[i].volume);
        uPrice.push(this.tableData[i].price);
      }
      await this.Apps.registerBulkOffer(
        uDateFrom,
        uDateTo,
        uTimeFrom,
        uTimeTo,
        uVolume,
        uPrice
      );
      uploadBcId = this.$store.state.block.updateReceiptStatus;
      for (var j = 0; j < this.tableData.length; j++) {
        (this.offer.companyCode = this.$store.state.auth.user.companyCode),
          (this.offer.locationCode = this.tableData[j].locationCode),
          (this.offer.assetCode = this.tableData[j].assetCode),
          (this.offer.dayType = this.tableData[j].dayType),
          (this.offer.dateFrom = this.tableData[j].dateFrom),
          (this.offer.dateTo = this.tableData[j].dateTo),
          (this.offer.timeFrom = this.tableData[j].timeFrom),
          (this.offer.timeTo = this.tableData[j].timeTo),
          (this.offer.volume = this.tableData[j].volume),
          (this.offer.unit = this.tableData[j].unit),
          (this.offer.bidDeadline = this.tableData[j].bidDeadline),
          (this.offer.price = this.tableData[j].price),
          (this.offer.bcId = uploadBcId[j]);

        await this.saveOffer();
      }
    },

    toDate(dateStr) {
      console.log("CHECK... dateStr: ", dateStr);
      var dateParts = dateStr.split("-");
      console.log("THEN... date: ", dateParts[2], dateParts[1], dateParts[0]);
      return new Date(dateParts[0], dateParts[1] - 1, dateParts[2]);
    },

    toTime(timeStr) {
      console.log("CHECK... timeStr: ", timeStr);
      console.log(
        "THEN... time: ",
        moment(timeStr, "HH:mm:ss").format("HH:mm:ss")
      );
      return moment(timeStr).format("HH:mm:ss");
    },
  },

  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },

    showCountry() {
      if (this.currentUser && this.currentUser.roles) {
        return this.currentUser.roles.includes("ROLE_ADMIN");
      }

      return false;
    },
    getLoc() {
      return this.loc;
    },
  },

  async mounted() {
    this.$store.state.auth.user;
    this.retrieveCountries();
    const cou = await LocationDataService.findBySubCountryCode(
      this.$store.state.auth.user.countryCode
    );
    this.loc = await cou.data;
    /* 
    this.$nextTick(function () {
      
    }); 
    */
  },
};
</script>

<style lang="scss">
@import "../../sass/main.scss";

.nav-bar {
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.2);
  margin-top: -100px;
  margin-left: -10px;
}

.asset-container {
  margin-top: -100px;
}

.offer-container {
  min-height: 100vh;
  background: #f8fcff;
}

.offer-inner-container {
  padding: 40px;
}

.upload-title .v-icon.v-icon.v-icon--link {
  position: absolute;
  top: 0px;
  right: -30px;
  z-index: 10000;
}

.offer-table-wrapper {
  box-shadow: 0 4px 6px 0 hsla(0, 0, 0, 0.2);
}

.top-offer-table-bar {
  background: #f9fafe;
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #f0f3fb;
}

.offer-search-wrapper {
  display: flex;
  align-items: center;
  width: 30%;
  max-width: 300px;
}

.upload-title {
  position: relative;
}

.offer-input {
  display: inline-block;
  font-size: 0.9rem;
  color: $black;
  line-height: 1.3;
  padding: 0.6em 0.4em 0.5em 0.8em;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  margin: 0 10px 0 0;
  border: 1px solid #aaa;
  box-shadow: 0 1px 0 1px rgba(0, 0, 0, 0.04);
  border-radius: 0.1em;
  -moz-appearance: none;
  -webkit-appearance: none;
  appearance: none;
}

.offer-input:focus,
.offer-search-button:focus {
  outline: none;
  border: 1px solid #6680a0;
  box-shadow: 0 0 5px #c8d2da;
}

.offer-add-button {
  font-size: 0.9rem;
  color: $black;
  padding: 6px 15px;
  background: #bfecb5;
  border: 1px solid #aaa;
  box-shadow: 0 1px 0 1px rgba(0, 0, 0, 0.04);
  margin-right: 10px;
}

.offer-remove-button {
  font-size: 0.9rem;
  color: $black;
  padding: 6px 15px;
  background: #f8736b;
  border: 1px solid #aaa;
  box-shadow: 0 1px 0 1px rgba(0, 0, 0, 0.04);
}

.offer-table {
  background: #fff;
  width: 100%;
}

.offer-table th {
  color: #4a4a4a;
  font-size: 16px;
  //text-transform: uppercase;
  font-weight: 600px;
  padding: 15px;
  text-align: left;
  border-bottom: 1px solid #e6e6e6;
}

.offer-table td {
  color: #4a4a4a;
  font-size: 14px;
  font-weight: 600px;
  padding: 15px;
  text-align: left;
  border-bottom: 1px solid #e6e6e6;
}

.offer-table tr:hover {
  background: #f5f8fd;
}

.table-button {
  background: none;
  border: none;
  padding: 0 5px;
  color: #007bff;
}

.table-button:hover {
  text-decoration: underline;
  color: #007bff;
}

.list {
  text-align: left;
  max-width: 750px;
  margin: auto;
}

.asset-filter-wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  margin-bottom: 30px;
}

.chips-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-top: 5px;
}

.chips-main {
  max-width: 200px;
  margin: 0 40px;
}

.divider2 {
  margin: 20px -140px 10px -140px;
  min-width: 800px;
}

.v-input--selection-controls {
  margin: 10px 0 20px 0 !important;
}

.offer-button-wrapper {
  display: flex;
}

.loading-wrapper {
  margin: 0 auto;
  padding: 15px 0;
  position: relative;
}

.loader-text {
  width: 100%;
  text-align: center;
  font-size: 18px;
  position: absolute;
  top: 0;
  left: 0;
}
</style>